import { render, staticRenderFns } from "./CommandsConfig.vue?vue&type=template&id=c5b2266e"
import script from "./CommandsConfig.vue?vue&type=script&lang=js"
export * from "./CommandsConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports